import { gql } from "@apollo/client";

export const GetCollectionBySlug = gql`
  query getCollectionBySlug($slug: String!, $apiKey: String!) {
    getCollectionBySlug(slug: $slug, apiKey: $apiKey) {
      id
      name
      cover_image
      thumbnail
      description
      packages {
        id
        name
        slug
        status
        thumbnail
        products {
          id
          name
          description
          product_variants {
            plan_product_variants {
              premium_price
            }
          }
        }
      }
    }
  }
`
